// «¿A qué se dedica tu negocio?» (26/9/2026): solo con el sector «otro». Viaja como
// `sector_detail` en TODAS las llamadas a /public/signup/start (como los UTM) y lo usa el
// asistente de IA para proponer servicios propios del negocio en vez del catálogo genérico.
export const SECTOR_DETAIL_MAX = 80;

export const SECTOR_DETAIL_TEXT = {
  es: {
    label: "¿A qué se dedica tu negocio?",
    placeholder: "Ej.: Limpieza y cuidado de mayores",
    required: "Cuéntanos a qué se dedica tu negocio.",
  },
  va: {
    label: "A què es dedica el teu negoci?",
    placeholder: "Ex.: Neteja i cura de persones majors",
    required: "Conta'ns a què es dedica el teu negoci.",
  },
  en: {
    label: "What does your business do?",
    placeholder: "E.g.: Cleaning and elderly care",
    required: "Tell us what your business does.",
  },
};

export function sectorDetailLang(lang) {
  const l = String(lang || "").toLowerCase();
  if (l.startsWith("ca") || l.startsWith("va")) return "va";
  if (l.startsWith("en")) return "en";
  return "es";
}

/** Texto limpio para el POST, o undefined (otro sector o vacío: el cuerpo no cambia). */
export function sectorDetailPayload(sector, detail) {
  if (sector !== "otro" || typeof detail !== "string") return undefined;
  const s = detail.replace(/\s+/g, " ").trim().slice(0, SECTOR_DETAIL_MAX).trim();
  return s || undefined;
}
